import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { loginUserRole } from '../utils/constant';

const useFilteredMenuItems = (permissions, isEmployee, menuItems) => {
  const user_details = useSelector((state) => state?.userInfo?.data?.user_details);
  const loggedUserRole = useSelector((state) => state?.userInfo?.role);
  const allowedModules = useMemo(() => {
    return new Set(
      permissions
        ?.filter((perm) => perm.read && (!isEmployee || perm.module !== 'Employee'))
        .map((perm) => perm.module.toLowerCase())
    );
  }, [permissions, isEmployee]);

  const checkEmpPermission = useMemo(() => {
    return permissions?.find((ele) => ele?.module === 'Employee');
  }, [permissions]);

  const filteredMenuItems = useMemo(() => {
    const skipFilterRoutes = isEmployee
      ? ['myprofile', ...[user_details?.reporting_permission && 'requests']]
      : ['requests'];

    if (
      checkEmpPermission &&
      !isEmployee &&
      checkEmpPermission?.read &&
      checkEmpPermission?.create &&
      checkEmpPermission?.update &&
      checkEmpPermission?.del
    ) {
      skipFilterRoutes.push('salary-records');
    }

    if (user_details?.isBusinessUser && isEmployee) {
      skipFilterRoutes.push('leads');
    }

    if (
      loggedUserRole?.role === loginUserRole.ADMIN ||
      loggedUserRole?.role === loginUserRole.SUPERADMIN
    ) {
      skipFilterRoutes.push('reports');
    }

    return menuItems.filter(
      (item) => skipFilterRoutes.includes(item.routeName) || allowedModules.has(item.routeName)
    );
  }, [allowedModules, isEmployee, menuItems]);

  return filteredMenuItems;
};

export default useFilteredMenuItems;
